import React from 'react';
import { Grid, Typography, Box, Button, Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import Format from "../../utils/Format";
import './index.css';

const VariantInfoGrid = ({
  variantName,
  gene,
  condition,
  hgvsNames,
  variantType,
  annotationLastUpdated,
  onViewAnnotationData,
  annotationDisabled = false,
  annotationDisabledMessage = 'No annotation data available.',
  children,
}) => {
  return (
    <Box className="variant-details-container">
      <Grid container spacing={2}>
        {/* Left 50% column: existing label/data rows */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            {variantName && (
              <Grid item xs={12}>
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <Typography component="div" variant="body2" className="variant-info-label">
                      Variant Name:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography component="div" variant="body1" className="variant-info-value">
                      {variantName || ''}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} sm={6}>
                  <Typography component="div" variant="body2" className="variant-info-label">
                    Gene:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography component="div" variant="body1" className="variant-info-value gene">
                    {Format.CommaSeparatedList(gene)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} sm={6}>
                  <Typography component="div" variant="body2" className="variant-info-label">
                    Potential Condition:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography component="div" variant="body1" className="variant-info-value">
                    {Format.CommaSeparatedList(condition)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="flex-start">
                <Grid item xs={12} sm={6}>
                  <Typography component="div" variant="body2" className="variant-info-label">
                    HGVS Names:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography component="div" variant="body1" className="variant-info-value">
                    {hgvsNames}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* Right 50% column: annotation info rows above the action button */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            {variantType && (
              <Grid item xs={12}>
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <Typography component="div" variant="body2" className="variant-info-label">
                      Variant Type:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography component="div" variant="body1" className="variant-info-value">
                      {variantType}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {annotationLastUpdated && (
              <Grid item xs={12}>
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <Typography component="div" variant="body2" className="variant-info-label">
                      Annotation Last Updated:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography component="div" variant="body1" className="variant-info-value">
                      {annotationLastUpdated}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      className="variant-annotation-button"
                      onClick={onViewAnnotationData}
                      disabled={annotationDisabled}
                    >
                      View Annotation Data
                    </Button>
                    {annotationDisabled && (
                      <Tooltip
                        title={annotationDisabledMessage}
                        placement="top"
                        arrow
                        componentsProps={{ tooltip: { sx: { fontSize: '14px' } } }}
                      >
                        <span
                          tabIndex={0}
                          role="button"
                          aria-label={annotationDisabledMessage}
                          style={{ marginLeft: '8px', display: 'inline-flex', cursor: 'pointer' }}
                        >
                          <InfoOutlined sx={{ fontSize: '1.1rem', color: 'var(--info-color)', verticalAlign: 'middle' }} />
                        </span>
                      </Tooltip>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {children && (
          <Grid item xs={12}>
            {children}
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default VariantInfoGrid;